<template>
   <div class="leads-page">
      <div class="mt-3">
         <Lead/>
      </div>
   </div>
</template>

<script>
import Lead from '@/components/Leads/Lead.vue';

export default {

	components: {
		Lead,
	},

}
</script>